// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---go33b","changedRecordsList":"changedRecordsList---hQBbf","changedRecord":"changedRecord---hv4Cz"};